import { render } from "./SoftCheckbox.vue?vue&type=template&id=0fc1a252"
import script from "./SoftCheckbox.vue?vue&type=script&lang=js"
export * from "./SoftCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\dxworks\\Downloads\\dpp_adm_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__